import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { AuthorFormComponent } from '../../../components/author/author-form/author-form.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-authors-index',
  standalone: true,
  imports: [
    CommonModule,
    AuthorFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './authors-index.component.html',
  styleUrl: './authors-index.component.scss'
})
export class AuthorsIndexComponent {
  items : []  = [];
	private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = AuthorFormComponent;

  constructor () {}  

	openModal(item: any) {    
    let self = this;
    console.log(self.reloadItems);
		const modalRef = this.modalService.open(AuthorFormComponent);
		modalRef.componentInstance.modalStyle = true;
		modalRef.componentInstance.item = item;
    modalRef.componentInstance.modalInstance = modalRef;
		modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
	}
}
